import { Component, DestroyRef, Inject, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DOCUMENT } from "@angular/common";
import { SearchService } from "@app/services/search-service";

@Component({
    selector: "app-search-results-page",
    templateUrl: "./search-results-page.component.html",
    styleUrl: "./search-results-page.component.scss",
})
export class SearchResultsPageComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    pageTitleArea: pageTitle[] = [{ title: "Search Results" }];
    searchResults: [] = [];
    rootUrl: string = "";

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private searchService: SearchService,
    ) {
        this.rootUrl = `${this.document.location.origin}/`;
    }

    ngOnInit(): void {
        this.searchService.searchResults$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((results) => {
                this.searchResults = results as any;
            });
    }
}

class pageTitle {
    title: string;
}
